import React from 'react';


const SlideOne = () => {
    return (
        <section
            className="h-screen w-full flex flex-col justify-center px-10 md:px-40 relative text-black"
        >
            {/* LIFE. */}
            <div className="relative inline-block w-fit">
                <div className="flex items-baseline space-x-1">
                    <span className="text-[15vh] md:text-[36vh] font-thin font-bebas leading-none tracking-tight transform ">
                        LIFE.
                    </span>
                </div>
                <div className="absolute h-1 bg-red-500 left-0 top-[45%] w-[100%] -translate-y-1/2" />

            </div>

            {/* EDITED. */}
            <div className="relative inline-block w-fit transform md:-mt-12">
                <span className="text-[15vh] font-bebas md:text-[36vh] font-bebas leading-none tracking-tight ">
                    EDITED.
                </span>

            </div>
            <div className=" relative h-1 bg-red-500 left-0 -bottom-8 md:-bottom-10 -bottom-2 w-[100%]" />

            {/* Scroll Arrow */}
            <div className="absolute right-10 bottom-10 text-4xl">↓</div>
        </section>
    );
};

export default SlideOne;
